<template>
  <mainTemplate>
    <div class="party-wrap">
      <div class="add-party-btn">
        <a-button icon="plus" @click="bindThirdUser">
          <span>绑定第三方账号</span>
        </a-button>
      </div>
      <div class="platform">
        <template v-for="(list, index) in arr">
          <div class="plat-item flex-wrap" :key="index">
            <div class="col-flex-7">
              <div class="plat-tit1">{{ list.domain | domainType }}</div>

              <div class="plat-tit2">账号：{{ list.account }}</div>
            </div>
            <div class="col-flex-1 exe-buts">
              <a-button
                type="primary"
                class="ant-btn tkn-btn_s tkn-btn_default"
                @click="modifyItem(index)"
              >
                修改
              </a-button>
              <a-button class="ant-btn tkn-btn_s tkn-btn_normal" @click="delItem(index)">
                删除
              </a-button>
            </div>
          </div>
        </template>
      </div>
      <ThirdPartyModal
        v-model="visibleThird"
        @on_cancel="closeThird"
        @add="addItem"
      ></ThirdPartyModal>
      <ModifyThirdPartyModal
        :info="currentItem"
        v-model="modifyVisible"
        @on_cancel="closeModifyThird"
        @on_modified="modifySuccess"
      ></ModifyThirdPartyModal>
      <Modal
        v-model="delVisible"
        :hasFooter="true"
        :customFooter="false"
        @on_cancel="closeModal"
        @on_ok="okClose"
      >
        <template slot="body">
          <img src="@/assets/svg/问号.svg" alt="" />
          <span class="custom-tit">确定要删除吗？</span>
          <div class="custom-body">
            {{ this.currentItem.domain | domainType }} ：{{ this.currentItem.account }}
          </div>
        </template>
      </Modal>
    </div>
    <no-binds v-show="arr.length == 0">
      <template slot="party">
        <div class="noresult__mid">
          <div class="font-large font-color">还没有绑定的账号哦～</div>
          <div class="font-large font-color">快去添加吧</div>
        </div>
      </template>
    </no-binds>
  </mainTemplate>
</template>
<script>
import { msgTip } from '@/utils/urlUtils'
import { api_post, api_get } from '@/utils/http.ts'
import ThirdPartyModal from '@/components/enroll/ThirdPartyModal.vue'
import ModifyThirdPartyModal from '@/components/enroll/ModifyThirdPartyModal.vue'
import mainTemplate from '@/components/MainTemplate.vue'
import Modal from '@/components/enroll/Modal.vue'
import NoBinds from '@/components/common/noBinds/NoBinds.vue'
export default {
  name: 'party',
  data() {
    return {
      currentItem: { domain: '', account: '', account_id: 1 },
      //账号数据
      arr: [],
      visibleThird: false,
      modifyVisible: false,
      delVisible: false
    }
  },
  components: {
    mainTemplate,
    ThirdPartyModal,
    ModifyThirdPartyModal,
    Modal,
    NoBinds
  },
  methods: {
    modifySuccess(item) {
      // this.arr[this.currentIndex] = item
      this.arr = item || []
    },
    addItem(d) {
      this.arr = d.data || []
    },
    async getInit() {
      let rdata = await api_get('/search/api/auth/account/all', {})
      if (rdata.success) {
        this.arr = rdata.data
      } else {
        this.arr = []
      }
    },
    closeModal() {
      this.delVisible = false
    },
    async okClose() {
      let rdata = await api_post('/search/api/auth/account/remove', {
        account_id: this.currentItem.account_id
      })
      if (rdata.success) {
        this.delVisible = false
        this.arr = rdata.data
        // this.arr.splice(this.currentIndex, 1)
        msgTip({
          type: 'success',
          msg: '删除成功'
        })
      } else {
        msgTip({
          type: 'error',
          msg: rdata.error || 'error'
        })
      }
    },
    delItem(index) {
      this.currentItem = this.arr[index]
      this.currentIndex = index
      this.delVisible = true
    },
    closeThird() {
      this.visibleThird = false
    },
    bindThirdUser() {
      this.visibleThird = true
    },
    closeModifyThird() {
      this.modifyVisible = false
    },
    modifyItem(index) {
      this.modifyVisible = true
      this.currentItem = this.arr[index]
      this.currentIndex = index
    }
  },
  mounted() {
    this.getInit()
  }
}
</script>
<style lang="scss">
.party-wrap {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  .add-party-btn {
    button {
      width: 152px;
      height: 32px;
      background: rgba(0, 122, 255, 1);
      border-radius: 2px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
    }
    padding-bottom: 20px;
    text-align: right;
  }
  .platform {
    .plat-item {
      .exe-buts {
        text-align: right;
      }
      .exe-buts button:nth-child(1) {
        margin-right: 17px;
      }
      margin-bottom: 10px;
      padding: 20px;
      border-radius: 2px;
      border: 1px solid rgba(217, 217, 217, 1);
      .plat-tit1 {
        width: 60px;
        height: 24px;
        font-size: 16px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 24px;
      }
      .plat-tit2 {
        // width: 132px;
        width: 300px;
        height: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 22px;
      }
    }
  }
}
</style>
